// Дата платежа в диалоге «Редактирование» (CompanyCounts.vue): что слать в counts#update.
//
// created_at платежа — настоящий инстант (не настенное время брони, см. @/utils/wallClock).
// Раньше диалог помечал дату изменённой по @input пикера, а v-calendar эмитит input сам, как
// только получает значение с сервера, — и дата уходила при каждом сохранении. Причём строкой
// «DD-MM-YYYY H:mm» в поясе браузера без смещения, которую API читает в поясе филиала: секунды
// обрезались, ставился old_created_at, а при разных поясах платёж сдвигался на их разницу.
//
// Поэтому изменение определяется сравнением, а не событием: та же минута (пикер секунд не знает)
// — не изменение, null. Иначе — ISO 8601 со смещением: момент однозначен в любом поясе.
import moment from "moment";

// Пикер отдаёт Date, сервер — ISO 8601; иное не угадываем (moment без формата предупреждает).
const toMoment = (value) => (value instanceof Date ? moment(value) : moment(value, moment.ISO_8601));

export function paymentDateForSave(original, edited) {
  if (!edited) return null;
  const after = toMoment(edited);
  if (!after.isValid()) return null;
  const before = original ? toMoment(original) : null;
  if (before && before.isValid() && after.isSame(before, "minute")) return null;
  return after.format();
}
